import React from 'react';
import ImagemVisa from 'assets/img/icones/icon-visa.png';

const LogoVisa = props => {
  return (<img src={ImagemVisa} width="100" heigth="56" alt="Visa" />)
};
export default LogoVisa;